export enum LocalSettingsKey {
  USER = 'ym@user',
  DEVICE_ID = 'y@uuid',
  ACTIVE_SESSIONS = 'ym@activeSessions',
  ACTIVE_SESSION_CHANGES = 'ym@activeSessionChange',
  ACTIVE_SESSION_CHANGED = 'ym@sessionChanged',
  LOGOUTED_SESSION = 'ym@logoutedSession',
  CALENDAR_EVENTS = 'ym@calendarEvents',
  POPOUT_COMPOSE_DATA = 'ym@popoutComposeData',
  PREFERENCES = 'ym@preferences',
  TRANSLATE = 'ym@translate',
  POPOUT_WINDOW_SIZE = 'ym@popoutWindowSize',
  SETTINGS_UPDATED = 'ym@settingsUpdated',
  LISTING_TYPE = 'ym@listingType',
  CALENDAR_VIEW = 'ym@calendarView',
  PROFILE_PHOTO_UPDATED = 'ym@profilePhotoUpdated',
  SSO_DEVICE_ID = 'ym@sso_device_id',
  CALENDAR_START_TIME = 'ym@calendarStartTime',
  CALENDAR_UPDATE_TIME = 'ym@calendarUpdateTime',
  RESIZE = 'ym@resize',
  RESIZE_HORIZONTAL = 'ym@resizeHorizontal',
  POPOUT_EVENT = 'ym@popoutEvent',
  POPOUT_COMPOSE_READY = 'ym@popoutComposeReady',
  MAILBOXES = 'ym@mailboxes',
  REMINDER_SWITCH_UPDATED = 'ym@remindersSwitchUpdated',
  IS_BANNER_SEEN = 'ym@isBannerSeen',
  LOGGED_OUT = 'loggedOut',
  THEME = 'ym@theme',
  READ_PANE_TEMPLATE = 'ym@readPaneTemplate',
  VERSION_UPDATE = 'ym@versionUpdate',
  IS_TOKEN_RENEWING = 'ym@isTokenRenewing',
  REMEMBER_ME = 'ym@rememberMe',
  EMAIL_PREFERENCE = 'ym@emailPreference',
  MSG_PREVIEW_SETTING = 'ym@msgPreviewSetting',
  AI_WELCOME_SEEN = 'ym@aiWelcomeSeen',
}

export const getUserLocal = (property?: string): any => {
  let user = localStorage.getItem(LocalSettingsKey.USER);
  if (user) {
    user = JSON.parse(user);
    return property ? user[property] : user;
  }
  return null;
};
